import { render, staticRenderFns } from "./yi_upload.vue?vue&type=template&id=bd55ef10&scoped=true&"
import script from "./yi_upload.vue?vue&type=script&lang=js&"
export * from "./yi_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd55ef10",
  null
  
)

export default component.exports